import React, { useState } from 'react';
import { Col, Layout, Row, Space, Tooltip, Typography } from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomSelector } from '../../../components';
import { getProjectsActive } from '../../../api/module/project_person';
import Paragraph from 'antd/es/typography/Paragraph';
import AjaxTable from '../../../components/AjaxTable';
import { queryUnit as filterUnit } from '../../../api/module/unit';
import { EyeFilled } from '@ant-design/icons';
import { queryUnitFormForms } from '../../../api/module/unit_form';
import INTERNAL_LINKS from '../../../enums/InternalLinks';

const { Content } = Layout;
const { Title } = Typography;

export default function FormsFillOut({history}) {
  const [selectedProject, setSelectedProject] = useState(undefined);
  const [queryUnits, setQueryUnits] = useState(undefined);
  const [reloadUnit, setReloadUnit] = useState(false);
  const [reloadFormNested, setReloadFormNested] = useState(false);

  const columnsUnit = [
    {
      title: 'Tipo Estructura',
      dataIndex: 'nombre_estructura',
      key: 'nombre_estructura',
    },
    {
      title: 'Detalle 1',
      dataIndex: 'detalle1',
      key: 'detalle1',
    },
    {
      title: 'Detalle 2',
      dataIndex: 'detalle2',
      key: 'detalle2',
    },
    {
      title: 'Detalle 3',
      dataIndex: 'detalle3',
      key: 'detalle3',
    },
    {
      title: 'Detalle 4',
      dataIndex: 'detalle4',
      key: 'detalle4',
    },
  ];

  const columnsForm = [
    {
      title: 'Cod',
      dataIndex: 'codigo',
      key: 'codigo',
    },
    {
      title: 'Formulario',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Categoría',
      dataIndex: 'categoria',
      key: 'categoria',
    },
    {
      title: 'Múltiple',
      dataIndex: 'multiple',
      key: 'multiple',
      align: 'center',
      render: (text) => (text ? 'Sí' : 'No'),
    },
    {
      title: 'Cantidad de Registros',
      dataIndex: 'diligenciados',
      key: 'diligenciados',
      align: 'center',
    },
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Tooltip title='Ver Diligenciamientos' placement='top'>
            <EyeFilled
              onClick={() => viewSummary(record.id)}
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const breadcrumbItems = [
    {
      text: 'Formularios - Diligenciamiento',
    },
  ];

  const initialQuery = (project) => {
    if (selectedProject === undefined) {
      setSelectedProject(project);
    }
    setQueryUnits("filter[proyecto]="+project);
  };

  const expandedRowForms = (record) => {
    return (
      <AjaxTable
        columns={columnsForm}
        tableTitle={'Formularios Asignados'}
        endpoint={queryUnitFormForms}
        reloadSource={reloadFormNested}
        scroll={{ x: false }}
        query={`filter[unidad]=${record.id}&filter[proyecto]=${selectedProject}&filter[activo]=true`}
        searchInput
      />
    );
  };

  const viewSummary = (id) => {
    history.push(`${INTERNAL_LINKS.FORM_SUMMARY}/${id}`);
  };

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Formularios - Diligenciamiento
          </Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={2}>
          <Paragraph>Proyecto:</Paragraph>
        </Col>
        <Col span={17}>
          <CustomSelector
            selectorProps={{
              style: { width: '100%' },
              placeholder:
                'Seleccione el proyecto... ',
            }}
            endpointFetch={async () => {
              return await getProjectsActive();
            }}
            onChange={(value) => initialQuery(value)}
          />
        </Col>
      </Row>
      {selectedProject && (
        <>
          <Row style={{ marginTop: '20px' }}>
            <Col span={24}>
              <AjaxTable
                expandedRowRender={{ expandedRowRender: expandedRowForms }}
                tableTitle={'Listado de unidades asignadas al proyecto'}
                rowKey={'id'}
                endpoint={filterUnit}
                query={queryUnits}
                columns={columnsUnit}
                searchInput={true}
                reloadSource={reloadUnit}
              />
            </Col>
          </Row>
        </>
      )}
    </Content>
  )
}
